import { useCountdown } from "./useCountdown";
import "../css/countdownTimer.scss";
import React, { useState, useEffect } from 'react';
import "../css/timeDisplay.scss";

const TimeDisplay = ({ value, type, isDanger }) => {
  return (
    <div className={isDanger ? "countdown-danger" : "countdown"}>
      <span className="number">{value}</span>
      <span>{type}</span>
    </div>
  );
};

const ExpiredNotice = () => {
  return <div>El tiempo ha expirado.</div>;
};

const ShowCounter = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="show-counter">
      <TimeDisplay value={days} type={'Dias'} isDanger={days <= 1} />
      <TimeDisplay value={hours} type={'Horas'} isDanger={days <= 1 && hours <= 6} />
      <TimeDisplay
        value={minutes}
        type={'Minutos'}
        isDanger={days <= 1 && hours <= 6 && minutes <= 60}
      />
      <TimeDisplay
        value={seconds}
        type={'Segundos'}
        isDanger={days <= 1 && hours <= 6 && minutes <= 60 && seconds <= 60}
      />
    </div>
  );
};

const CountdownTimer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = targetDate - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (Object.keys(timeLeft).length === 0) {
    return <ExpiredNotice />;
  }

  return (
    <ShowCounter
      days={timeLeft.days}
      hours={timeLeft.hours}
      minutes={timeLeft.minutes}
      seconds={timeLeft.seconds}
    />
  );
};

export default CountdownTimer;
